/**
 * Area classification flags:
 * - r: rural
 * - t: town
 * - s: suburban
 * - u: urban
 */
export const AREA_FLAGS = ['r', 't', 's', 'u']

/**
 * School type classification flags:
 * - rg: regular
 * - ch: charter
 * - mg: magnet
 * - bie: Beaureu of Indian Education
 */
export const SCHOOL_TYPE_FLAGS = ['rg', 'ch', 'mg', 'bie']

/**
 * School age group flags:
 * - m: middle school
 * - e: elementary school
 * - c: combined school (middle + elementary)
 */
export const SCHOOL_AGE_FLAGS = ['m', 'e', 'c']

/**
 * Filter flags available for location types
 */
export const FILTER_FLAGS = {
  states: [],
  counties: [],
  districts: [AREA_FLAGS],
  schools: [AREA_FLAGS, SCHOOL_TYPE_FLAGS, SCHOOL_AGE_FLAGS]
}

// add BIE filter to embargoed
// FILTER_FLAGS['schools'][1].push(['bie'])

// these flags only show locations with corresponding flags when active
// not currently in use, but was used for BIE filter, and left in incase
// the functionality is required in the future
export const EXCLUSIVE_FLAGS = []
